import {
  CustomerCategoryTitleUI,
  GridUI,
} from '@next-order/next-order-components';
import { MenuContext } from 'contexts/MenuProvider';
import { CATEGORY_DISPLAY_TYPE_VALUE } from 'helpers/enums';
import titleCase from 'helpers/titleCase';
import { forwardRef, useContext } from 'react';

import MenuItem from './MenuItem';
import SpecialsItem from './SpecialsItem';

const SimpleOrSpecialMenuItemsCategoryContainer = forwardRef(
  ({ category, onClickItemHandler, currency }, ref) => {
    const { mappedSelectedMenuItemQuantities } = useContext(MenuContext);

    const display = CATEGORY_DISPLAY_TYPE_VALUE[category.displayType] ?? 'grid';
    const rawDescription = category?.description || '';
    const isHtmlDescription =
      typeof rawDescription === 'string' &&
      /<\/?[a-z][\s\S]*>/i.test(rawDescription);

    return category?.data?.length > 0 ? (
      <>
        <CustomerCategoryTitleUI ref={ref}>
          <div className='flex flex-col gap-1'>
            <span>{titleCase(category.name)}</span>
            {rawDescription &&
              (isHtmlDescription ? (
                <span
                  className='text-sm font-normal text-neutral-575 normal-case'
                  dangerouslySetInnerHTML={{ __html: rawDescription }}
                />
              ) : (
                <span className='text-sm font-normal text-neutral-575 normal-case'>
                  {rawDescription}
                </span>
              ))}
          </div>
        </CustomerCategoryTitleUI>

        {category.isSpecial ? (
          <GridUI align='start' gap='none' colsTemplate='cw-specials'>
            {category.data.map((menuItem, index) => (
              <SpecialsItem
                key={index}
                menuItem={menuItem}
                currency={currency}
                onClickItemHandler={onClickItemHandler}
                count={mappedSelectedMenuItemQuantities[menuItem.item?._id]}
              />
            ))}
          </GridUI>
        ) : (
          <GridUI align='start' gap='none' colsTemplate={`cw-${display}`}>
            {category.data.map((menuItem, index) => (
              <MenuItem
                key={index}
                menuItem={menuItem}
                currency={currency}
                displayType={display}
                onClickItemHandler={onClickItemHandler}
                count={mappedSelectedMenuItemQuantities[menuItem.item?._id]}
              />
            ))}
          </GridUI>
        )}
      </>
    ) : null;
  }
);

export default SimpleOrSpecialMenuItemsCategoryContainer;
